import { useState } from "react";
import { Check, Copy } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import styles from "./CopyButton.module.css";

type Props = { value: string; label?: string };

export function CopyField({ value, label }: Props) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      // Fallback: selektieren, User muss manuell kopieren
    }
  };

  return (
    <div>
      {label && (
        <span style={{ display: "block", fontSize: "var(--fs-sm)", fontWeight: 500, color: "var(--bm-ink-2)", marginBottom: "var(--sp-2)" }}>
          {label}
        </span>
      )}
      <div className={styles.wrap}>
        <span className={styles.value} title={value}>
          {value}
        </span>
        <Button
          type="button"
          variant={copied ? "ghost" : "secondary"}
          size="compact"
          onClick={onCopy}
          aria-label={t("common.copy")}
        >
          {copied ? (
            <>
              <Check size={16} weight="regular" />
              {t("common.copied")}
            </>
          ) : (
            <>
              <Copy size={16} weight="regular" />
              {t("common.copy")}
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
